export default __webpack_public_path__ + "static/media/kokila.ba2d6142.ttf";